import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  ClearBulkSearchOptions,
  ConfigurationNameChanged,
  GetProfilesSuccess,
  IsActiveChanged,
  PanelStatusChanged,
  ProfileModelChanged,
} from '../actions/search-bulk.actions';
import { SearchBulkState } from '../models/bulk.models';

const initialState: SearchBulkState = {
  panelExpanded: true,
  profileModelValues: [],
  profileModel: '',
  configurationName: '',
  isActive: true,
};

export const SearchBulkReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(ProfileModelChanged, (state, { profileModel }) => ({
    ...state,
    profileModel: profileModel ?? '',
  })),
  on(ConfigurationNameChanged, (state, { configurationName }) => ({
    ...state,
    configurationName,
  })),
  on(IsActiveChanged, (state) => ({
    ...state,
    isActive: !state.isActive,
  })),
  on(GetProfilesSuccess, (state, { res }) => {
    const profileModelValues = res.profiles.map((profiles: any) => [
      profiles.profileCode,
      profiles.profileModelList[0].modelName,
    ]);
    return {
      ...state,
      profileModelValues: profileModelValues,
    };
  }),
  on(ClearBulkSearchOptions, (state) => ({
    ...state,
    profileModel: '',
    configurationName: '',
    isActive: true,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    panelExpanded: true,
    profileModel: '',
    configurationName: '',
    isActive: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
